import { Injectable } from "@angular/core";
import { TipoArquivo } from "@tivic-team/manager-ts/dist/grl/entities/tipo-arquivo.entity";
import { TiposArquivosController } from "app/controllers/grl/tipos-arquivos.controller";
import { LoaderService } from "../loader.service";
import { TipoArquivoSearch } from "./tipos-arquivos.search";



@Injectable()
export class TiposArquivosServices {
    constructor(
        private _tipoArquivoController: TiposArquivosController,
        private _loaderService: LoaderService
    ) { }


    async find(tipoArquivoSearch?: TipoArquivoSearch): Promise<TipoArquivo[]> {
        this._loaderService.show();

        try {
            return await this._tipoArquivoController.find(
                (tipoArquivoSearch && tipoArquivoSearch.getFilters()) || null)
                .finally(() => this._loaderService.hide());
        } catch (error) {
            this._loaderService.hide()
            console.log(error);
            return [];
        }
    }

    async save(tipoArquivo: TipoArquivo): Promise<TipoArquivo> {
        console.log('Loading Tipo Arquivo Service...');
        this._loaderService.show();

        if (tipoArquivo.cdTipoArquivo && tipoArquivo.cdTipoArquivo > 0) {
            console.log('update');
            return this._tipoArquivoController.update(tipoArquivo).finally(() => this._loaderService.hide());
        } else {
            console.log('create');
            return this._tipoArquivoController.create(tipoArquivo).finally(() => this._loaderService.hide());
        }
    }

    async get(cdTipoArquivo: number): Promise<TipoArquivo> {
        this._loaderService.show();
        return this._tipoArquivoController.get(cdTipoArquivo).finally(() => this._loaderService.hide());
    }
}